/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Stage_DescriptionInputs */



/**
* | output |
* | --- |
* | "A full-screen card show, or an overlay for OBS" |
*
* @param {Nav_Stage_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_stage_description = /** @type {((inputs?: Nav_Stage_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Stage_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Kartenshow im Vollbild oder ein Overlay für OBS")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une vitrine de cartes en plein écran, ou un overlay pour OBS")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("全屏卡牌展示，或用于 OBS 的悬浮层")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("全螢幕卡牌展示，或給 OBS 使用的疊加層")
	if (locale === "ko") return /** @type {LocalizedString} */ ("전체 화면 카드 쇼 또는 OBS용 오버레이")
	return /** @type {LocalizedString} */ ("A full-screen card show, or an overlay for OBS")
});